import axios, { AxiosResponse } from 'axios'
import { UserInfo } from 'commons/dto/userInfo'
import { KeycloakToken } from 'commons/types/keycloakToken'
import { LocalStorageService } from 'utils/LocalStorageService'
import * as securityApi from 'api/easypay/security'
import { loadConstants } from 'api/api'

export const getToken = async ({
  email,
  password,
}): Promise<AxiosResponse<KeycloakToken>> => {
  const data = {
    username: email,
    password: password
  };

  return securityApi.authLogin(data);
}

export const refreshToken = async (
): Promise<AxiosResponse<KeycloakToken>> => {
  const { token } = LocalStorageService.getObject()
  if (!token) throw new Error('NO TOKEN FOUND')
  
  const { refresh_token } = token

  const data = {
    refreshToken: refresh_token
  };

  return securityApi.authLogin(data);
}

export const getUserInfo = async (token: string): Promise<AxiosResponse<UserInfo>> => {
  const constants = await loadConstants();
  const keycloakUserInfoUrl = constants.KEY_CLOACK.replace('/token', '/userinfo');
  return axios.get(keycloakUserInfoUrl, {
    headers: { 
      Authorization: `Bearer ${token}` 
    }
  });
}